/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsSwapV: {
  name: 'arrows-swap-v';
  data: string;
} = {
  name: 'arrows-swap-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.707 3.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L7 6.414V12a1 1 0 1 0 2 0V6.414l1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3ZM17 12a1 1 0 1 0-2 0v5.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L17 17.586V12Z" fill="currentColor"/></svg>`,
};
